import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {RadioV2Props} from './RadioV2props.interface';

export function RadioV2({checked, className, ...props}: RadioV2Props) {
  return (
    <div className="relative cursor-pointer">
      <input
        type="radio"
        className={twMerge('sr-only', className)}
        checked={checked}
        readOnly
        {...props}
      />
      <Icon
        type={checked ? IconType.RadioOnV2 : IconType.RadioOffV2}
        className="h-16pxr"
      />
    </div>
  );
}
